// Grounded in the app's actual features (not generic filler) so a reader can
// self-serve answers instead of every question becoming a support ticket.
export const FAQ_ITEMS = [
  {
    q: 'What reading levels does ZeroUp Reads use?',
    a: "Every book is tagged Beginner, Intermediate or Advanced. During onboarding (or anytime in Settings) you can set your reading level, and the Library's filters let you narrow to just your level.",
  },
  {
    q: 'What languages are books available in?',
    a: 'We publish in English, Swahili, Yoruba, Zulu, French, Hausa, Igbo, Pidgin, Kanuri, Tiv and Efik, with more being added through our Translation Portal. A book\'s detail page lists every language it\'s currently available in.',
  },
  {
    q: 'How do I request a book in another language?',
    a: 'Open any book\'s detail page and tap "Translate" — that sends a request to our translation team. Once a translator picks it up and it\'s reviewed and approved, the new language appears on the book automatically.',
  },
  {
    q: 'Can I read books without an internet connection?',
    a: 'Yes — tap "Save Offline" on a book\'s detail page to download it, then open it anytime from "My Downloads," even with no connection. Your reading progress syncs automatically once you\'re back online.',
  },
  {
    q: 'How do I become an author or translator?',
    a: 'Reach out through Contact Support below with a short note about what you\'d like to contribute. An administrator can grant Author, Translator, Editor or Publisher access from there.',
  },
  {
    q: 'I forgot my password — how do I get back in?',
    a: 'Use "Forgot password?" on the Sign In page. We\'ll send a reset link to your email — it stays valid for 30 minutes.',
  },
  {
    q: 'How is my reading progress saved?',
    a: 'Progress saves automatically as you read, right on your device, and shows up on your Dashboard — reading streaks, books completed and pages read all update in real time.',
  },
  {
    q: 'How do I change my account details?',
    a: 'Go to Settings from your profile menu to update your preferred language and reading font size. For anything else, use Contact Support.',
  },
];
